import _ from "lodash";
import Group from "./Group";
import Product from "./Product";
import Column from "./Column";
import Image from "./Image";

export default class Catalog {
  columns;
  products;
  groups;
  images;

  constructor(catalogWire, shortNames) {
    var images = catalogWire.spa_dto_photos.map(imageWire => new Image(imageWire, shortNames));
    var imageByNameLowerCase = _.keyBy(images, image => image.name.toLowerCase());
    var products = catalogWire.spa_dto_products.map(productWire => new Product(productWire, imageByNameLowerCase, shortNames));
    var skuToProduct = _.keyBy(products, product => product.sku);
    var slideshow = catalogWire.spa_dto_presentation;
    var groups = slideshow.presentation_dto_pages.map(groupWire => new Group(slideshow, groupWire, skuToProduct, imageByNameLowerCase, shortNames));
    var columns = catalogWire.spa_dto_columns.map(columnWire => new Column(columnWire));

    this.products = products;
    this.groups = groups;
    this.images = images;
    this.columns = columns;
  }
}
